import { render, staticRenderFns } from "./ErrorDisplayComponent.vue?vue&type=template&id=721e4c5e&scoped=true&"
import script from "./ErrorDisplayComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorDisplayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721e4c5e",
  null
  
)

export default component.exports